import * as HeaderUI from '../HeaderUI';
import { SvgIcon } from '../../../components/Icon';
import { USERPILOT_RESOURCE_CENTER } from '../../../config/constants';
import KubitTooltip from '../../../components/KubitTooltip';

const UserPilotHelp = () => {
  const enableUserpilot = window.userpilot;
  const tooltipMsg = enableUserpilot
    ? 'Help'
    : 'Userpilot is not available in current environment.';
  const openKubitResourceHelp = () => {
    if (enableUserpilot) {
      try {
        // Userpilot SDK is loaded and enabled via Segment
        window.userpilot.trigger(USERPILOT_RESOURCE_CENTER);
      } catch (error) {
        // Log a warning if Userpilot fails
        console.warn(
          'userpilot.trigger failed. Please verify the Userpilot is correctly initialized',
          error,
        );
      }
    }
  };

  return (
    <KubitTooltip content={tooltipMsg} placement="bottom">
      <HeaderUI.IconContainer onClick={openKubitResourceHelp}>
        <SvgIcon
          name="question"
          width={24}
          height={24}
          customFill="currentColor"
          isDisabled={!enableUserpilot}
        />
      </HeaderUI.IconContainer>
    </KubitTooltip>
  );
};

export default UserPilotHelp;
